export default "__VITE_ASSET__d759dcbd__"